<div class="set-stack">
  <p class="set-note" role="note">
    <span class="bk-sym" aria-hidden="true">info</span>
    <span>
      <strong>Notification settings are not available yet.</strong>
      Nothing on this page is saved. The alerts below are planned; their switches stay off until they can be turned
      on here.
    </span>
  </p>

  <section class="bk-panel set-panel" aria-labelledby="ns-title">
    <header class="set-panel__head">
      <div class="set-panel__intro">
        <h2 class="set-panel__title" id="ns-title">Planned email alerts</h2>
        <p class="set-panel__sub">Each alert will go to the email address you sign in with.</p>
      </div>
    </header>

    <ul class="ns__list" role="list">
      @for (alert of alerts; track alert.title) {
        <li class="ns__row">
          <div class="ns__text">
            <p class="ns__title">{{ alert.title }}</p>
            <p class="ns__desc">{{ alert.description }}</p>
          </div>
          <app-toggle
            [checked]="false"
            [disabled]="true"
            [label]="alert.title + ' (not available yet)'"
          ></app-toggle>
        </li>
      }
    </ul>
  </section>
</div>
